// i18n area 'vms' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da vms.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/vms.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './vms'

export const enGB: DeepPartial<typeof enUS> = {
  vms: {
    isoPicker: {
      catalog: 'Catalogue',
      unknownCatalog: 'Not in a visible catalogue',
      noIsos: 'No ready ISO images in this catalogue'
    },
    templatesTab: {
      exportAction: 'Export to catalogue (.tvtpl)',
      exportTitle: 'Export to catalogue',
      exportHint: 'The template is packed into a .tvtpl archive (hardware manifest + every disk flattened to qcow2) as a new VM Template file in the chosen catalogue. NICs, CD/DVD media and cloud-init do not travel — the format spec lists every deliberate omission.',
      importAction: 'Import from catalogue',
      importTitle: 'Import from catalogue',
      importHint: 'A ready VM Template file of the chosen catalogue becomes a template of the inventory: the file’s format (tvtpl, ova, ovf or naked qcow2) decides how it imports — you only pick the file.',
      importFile: 'Catalogue file',
      importNoFiles: 'No ready VM Template files in this catalogue — upload or export one first'
    },
    unusedDisksTab: {
      convertWarning: 'DESTRUCTIVE: the disk becomes a VM template file in the chosen catalogue — same storage, no bytes copied — and CEASES TO EXIST as a disk. There is no way back except creating a new disk from the template.',
      convertNameHint: 'The catalogue file\'s name — defaults to the disk\'s own',
      convertStarted: 'Conversion started — the template appears in the catalogue when the task completes.'
    },
    quickDeploy: {
      compatNote: 'QuickDeploy needs a QuickDeploy-compatible template: the platform customises the guest (network, domain, activation) on first boot.'
    }
  }
}
